import { ATLAS } from '../data/atlasConfig.js';

// Country boundary mask — loads pre-baked geometry from a static file.
// The geometry was extracted from OSM relation 51477 and simplified to ~30m
// tolerance. To regenerate, re-fetch from Overpass and run the build script.

// Counter-clockwise (RFC 7946 compliant exterior ring)
// Latitudes capped at ±85 to avoid Mercator projection singularity at ±90
const WORLD_RING = [[-180, -85], [180, -85], [180, 85], [-180, 85], [-180, -85]];

export async function fetchCountries() {
  try {
    const res = await fetch(ATLAS.boundaryUrl);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const geom = await res.json();

    let holes = [];
    if (geom.type === 'Polygon') {
      holes = [geom.coordinates[0]];
    } else if (geom.type === 'MultiPolygon') {
      holes = geom.coordinates.map(poly => poly[0]);
    }

    const mask = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [WORLD_RING, ...holes]
      }
    };

    return { mask };
  } catch (e) {
    console.warn('Failed to load country boundary:', e.message);
    return { mask: null };
  }
}
